/** Inline SVG icons for the /download page layout. */

export function AppleIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M11.64 8.36c-.02-2.08 1.7-3.08 1.78-3.13-1-1.46-2.54-1.66-3.08-1.68-1.32-.13-2.58.78-3.25.78-.68 0-1.72-.76-2.83-.74-1.46.02-2.8.85-3.55 2.16-1.52 2.63-.39 6.52 1.09 8.66.72 1.04 1.58 2.2 2.71 2.16 1.09-.04 1.5-.7 2.82-.7 1.31 0 1.68.7 2.82.68 1.17-.02 1.9-1.05 2.61-2.1.82-1.2 1.16-2.36 1.18-2.42-.03-.01-2.27-.87-2.29-3.45zM9.52 2.58c.6-.73 1.01-1.74.9-2.75-.87.04-1.92.58-2.54 1.31-.56.65-1.05 1.69-.92 2.69.97.08 1.96-.49 2.56-1.25z" />
    </svg>
  );
}

export function WindowsIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M1.5 2.5h5.8v5.8H1.5V2.5zm0 6.7h5.8v5.8H1.5V9.2zm6.7-6.7H14v5.8H8.2V2.5zm0 6.7H14v5.8H8.2V9.2z" />
    </svg>
  );
}

export function DownloadArrowIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <path d="M8 2.5v7M8 9.5l-2.5-2.5M8 9.5l2.5-2.5M3.5 13.5h9" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function GitHubIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M8 1.2a6.8 6.8 0 0 0-2.15 13.25c.34.06.47-.15.47-.33 0-.16-.01-.58-.01-1.13-1.91.42-2.32-.92-2.32-.92-.31-.8-.76-1.01-.76-1.01-.62-.42.05-.41.05-.41.69.05 1.05.71 1.05.71.61 1.05 1.6.75 1.99.57.06-.45.24-.75.43-.92-1.52-.17-3.12-.76-3.12-3.38 0-.75.27-1.36.71-1.84-.07-.17-.31-.86.07-1.79 0 0 .58-.19 1.9.7a6.5 6.5 0 0 1 3.5 0c1.32-.89 1.9-.7 1.9-.7.38.93.14 1.62.07 1.79.44.48.71 1.09.71 1.84 0 2.63-1.6 3.21-3.13 3.37.25.22.47.64.47 1.29 0 .93-.01 1.68-.01 1.9 0 .18.13.39.47.33A6.8 6.8 0 0 0 8 1.2z" />
    </svg>
  );
}

export function AppIconPlaceholder({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <rect x="4" y="4" width="40" height="40" rx="8" />
      <path d="M16 16l16 16M32 16L16 32" strokeLinecap="round" />
    </svg>
  );
}

export function ChipIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <rect x="2" y="2" width="12" height="12" rx="2" />
      <path d="M5 8h6M8 5v6" strokeLinecap="round" />
    </svg>
  );
}

export function LaptopIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <rect x="2" y="3" width="12" height="8" rx="1" />
      <path d="M1 12h14" strokeLinecap="round" />
    </svg>
  );
}

export function CubeIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <path d="M8 1.5L14 5v6l-6 3.5L2 11V5l6-3.5z" />
      <path d="M8 1.5v11M2 5l6 3.5L14 5" />
    </svg>
  );
}

export function AlertIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="6.5" />
      <path d="M8 5v3.5M8 10.5h.01" strokeLinecap="round" />
    </svg>
  );
}

export function ShieldIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <path d="M8 1.5l5.5 2v4.5c0 3.5-2.3 5.5-5.5 6.5C4.8 13.5 2.5 11.5 2.5 8V3.5L8 1.5z" />
      <path d="M6 8l1.5 1.5L10.5 6.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ListIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <path d="M2.5 4.5h11M2.5 8h11M2.5 11.5h11" strokeLinecap="round" />
    </svg>
  );
}

export function HelpIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="6.5" />
      <path d="M6.2 6.2a2 2 0 0 1 3.4 1.4c0 1.4-1.7 1.7-1.7 3.1M8 12h.01" strokeLinecap="round" />
    </svg>
  );
}

export function InfoIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="6.5" />
      <path d="M8 7v4M8 5.5h.01" strokeLinecap="round" />
    </svg>
  );
}

export function ClipboardIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <rect x="4.5" y="2.5" width="7" height="3" rx="1" />
      <path d="M5.5 5.5h5v8h-5v-8z" />
    </svg>
  );
}
